export { Input, type InputProps, type IInputProps } from './input';
